export function isInteriorViewId(nodeId: string | null | undefined): boolean {
  return !!nodeId && /\(INT\)(R|E)?/.test(nodeId);
}

export function getSectionId(nodeId: string): string {
  return nodeId.split('-')[0];
}

export function getRowId(nodeId: string): string {
  return nodeId.split('-').slice(0, -1).join('-');
}
